import { Link, useNavigate, useLocation } from "react-router-dom";
import Button from "../../../components/Button/Button";
import InputField from "../../../components/InputField/InputField";
import styles from "./ForgottenPassword.module.scss";
import { useEffect, useState } from "react";
import { isValidEmail } from "application/utilities/validations";
import api from "application/utilities/axiosIntance";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { Result } from "application/types/GetLoginDetails";
import { Spinner } from "react-bootstrap";
import { renderLinkOrSpan } from "presentation/components/SupportText/SupportText";
import { useTranslation } from 'react-i18next';

const ForgottenPassword = () => {

    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [success, setSuccess] = useState(false);
    const [loader, setLoader] = useState(false);
    const location = useLocation();
    const region = useSelector((state: RootState) => state.region.region);
    const { t } = useTranslation();

    const userEmail = location.state?.email || "";
    const fromTBFlow = location.state?.fromTBFlow || false;
    const layoutState = useSelector((state: RootState) => state.layout) as {
        data: Result;
        isLoading: boolean;
        error: string | null;
    };

    const { data, isLoading } = layoutState;

    const handleSubmit = () => {
        setMessage("");
        setSuccess(false);
        setLoader(true);

        const errors: string[] = [];

        if (!username.trim()) errors.push(t("FIELD_NAME_USERNAME"));
        if (!email.trim()) errors.push(t("FIELD_NAME_EMAIL_ADDRESS"));

        if (errors.length > 0) {
            const last = errors.pop();
            const fields = errors.join(", ");
            const message = errors.length
                ? t(region === "PT" ? "FIELD_REQUIRED_MULTIPLE_FP" : "FIELD_REQUIRED_MULTIPLE", { fields, last })
                : t("FIELD_REQUIRED_SINGLE", { field: last })

            setMessage(message.charAt(0).toUpperCase() + message.slice(1));
            setLoader(false);
            return;
        }

        if (!isValidEmail(email)) {
            setMessage(t("INVALID_EMAIL"));
            setLoader(false);
            return;
        }

        api.post("/Login/ForgottenPassword", {
            regionCode: region,
            userName: username,
            email: email
        })
            .then((response) => {
                const { isSuccess, result } = response.data;
                if (isSuccess) {
                    setSuccess(true);
                    setMessage(result?.responseMessage);
                } else {
                    setMessage(result?.responseMessage);
                }
            })
            .catch(() => {
                setMessage(t("GENERIC_UNEXPECTED_ERROR"));
            })
            .finally(() => {
                setLoader(false);
            });
    }

    useEffect(() => {
        if (fromTBFlow && userEmail) {
            setEmail(userEmail);
        }
    }, [fromTBFlow, userEmail]);

    if (isLoading) {
        return (
            <Spinner animation="border" variant="light" />
        );
    }

    const middleLinks = data?.middleLinks || [];


    return (
        <div className="d-flex justify-content-center align-items-center w-100">
            <nav className={`${styles.popup} px-5 py-4 mb-2`}>
                {!success ?
                    (<>
                        <div className="align-items-center justify-content-center">
                            <div>
                                <div className={`${styles.heading}`}>
                                    {t("FORGOT_PASSWORD_HEADING")}
                                </div>
                                <div className={`${styles.description}`}>
                                    {t("FORGOT_PASSWORD_INSTRUCTION")}
                                </div>
                            </div>
                        </div>
                        {message &&
                            <div className={`${styles.error} d-flex align-items-center justify-content-center pt-2 ps-1`}>
                                {message}
                            </div>
                        }
                        <form onSubmit={(e) => e.preventDefault()}>
                            <InputField value={username} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)} placeholder={t("FIELD_NAME_REGISTEREDUSERNAME")} autoFocus></InputField>
                            <InputField maxLength={100} value={email} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)} placeholder={t("FIELD_NAME_REGISTEREDEMAIL")}></InputField>
                            <Button type="submit" onClick={handleSubmit} label={t("BUTTON_SUBMIT")} loading={loader}></Button>
                            <Button label={t("BUTTON_CANCEL")} onClick={() => navigate("/")} />
                        </form>

                        <div className="mt-3 mb-2">
                            <div className={`justify-content-center mt-2 text-center ${styles.helpText}`}>
                                {middleLinks[4] && renderLinkOrSpan(middleLinks[4], "")}
                                {middleLinks[5] && renderLinkOrSpan(middleLinks[5], styles.details, "", true)}
                            </div>
                        </div>
                    </>)
                    :
                    (
                        <div className="align-items-center justify-content-center text-center">
                            <div className={`${styles.info} d-flex align-items-center justify-content-center pt-2 ps-1 mb-3`}>
                                {message}
                            </div>
                            <Link to="/" className="linkText ps-1">
                                {t("RETURN_MESSAGE")}
                            </Link>
                        </div>
                    )
                }
            </nav>
        </div>
    )
}

export default ForgottenPassword;